<template>
	<div class='container'>
		<div class='tab-box' >
			<div :class="item.class ?'check': 'no-check'" @click="divClick(item,index)" v-for="(item, index) in divList" :key="index">{{item.name}}</div>
		</div>
		<div class='tree-box'>
			<div class='btn-box'>
				<el-button type='primary' class='fx-big-btn'  size='small' plain @click="save">保存</el-button>
			</div>
			<el-tree
				ref="tree"
				:data="treeData[id]"
				show-checkbox
				node-key="id"
				@check='setCheckedKeys'
				:default-checked-keys="checkedArr[id]"
				:props="defaultProps">
			</el-tree>
		</div>
	</div>
</template>
<script>

export default {
	name: 'tree',
	components: {
	},
	props: {
		treeData: Object,
		treeId: String
	},
	data () {
		return {
			id: '01_0000_0000_00',
			divList: [
				{
					class: true,
					name: '卖家',
					code: '01_0000_0000_00'
				},
				{
					class: false,
					name: '装修',
					code: '16_0000_0000_00'
				},
				{
					class: false,
					name: '商品',
					code: '02_0000_0000_00'
				},
				{
					class: false,
					name: '库存',
					code: '13_0000_0000_00'
				},
				{
					class: false,
					name: '客户',
					code: '03_0000_0000_00'
				},
				{
					class: false,
					name: '支付',
					code: '04_0000_0000_00'
				},
				{
					class: false,
					name: '营销',
					code: '08_0000_0000_00'
				},
				{
					class: false,
					name: '订单',
					code: '07_0000_0000_00'
				},
				// {
				// 	class: false,
				// 	name: '结算中心',
				// 	code: '10_0000_0000_00'
				// },
				{
					class: false,
					name: '销售',
					code: '11_0000_0000_00'
				},
				{
					class: false,
					name: '权限',
					code: '05_0000_0000_00'
				},
				{
					class: false,
					name: '报表',
					code: '09_0000_0000_00'
				},
				{
					class: false,
					name: '系统',
					code: '06_0000_0000_00'
				},
				{
					class: false,
					name: '消息',
					code: '12_0000_0000_00'
				},
				{
					class: false,
					name: '首页',
					code: '14_0000_0000_00'
				}
			],
			checkedArr: {},
			checkedArrHalf: {},
			activeName: '1',
			showTree: true,
			defaultProps: {
				children: 'authority',
				label: 'name'
			}
		}
	},
	watch: {
		treeData: {
			handler (val) {
				// 判断val是否为{}
				if (Object.keys(val).length === 0) {
					return false
				}
				let list = this.divList
				this.checkedArr = {}
				this.checkedArrHalf = {}
				for (let i = 0; i < list.length; i++) {
					let	data = val[list[i].code]
					let checkArr = []
					let halfArr = []
					for (var j = 0; j < data.length; j++) {
						checkArr = checkArr.concat(data[j].checkAuthority)
						if (data[j].checkAuthority.length > 0) {
							halfArr = halfArr.concat(data[j].id)
						}
					}
					this.checkedArr[list[i].code] = checkArr
					this.checkedArrHalf[list[i].code] = halfArr
				}
			},
			immediate: true
		}
	},
	methods: {
		save () {
			if (this.treeId === '') {
				this.$message.error('请选择角色')
			} else {
				let list = this.divList
				let checkArr = this.checkedArr
				let halfArr = this.checkedArrHalf
				let arr = []
				for (let i = 0; i < list.length; i++) {
					if (checkArr[list[i].code].length > 0) {
						arr = arr.concat(list[i].code)
					}
					arr = arr.concat(checkArr[list[i].code])
					arr = arr.concat(halfArr[list[i].code])
				}
				let params = {
					roleId: this.treeId,
					ids: arr
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlIV}/account/authority/saveRoleAuthority`,
					data: params
				}).then(res => {
					if (res.result === true) {
						this.$message.success('权限保存成功！')
					} else {
						this.$message.error(res.msg)
					}
				})
			}
		},
		setCheckedKeys () {
			let id = this.id
			var checkArr =	this.$refs.tree.getCheckedKeys()
			var halfArr = this.$refs.tree.getHalfCheckedKeys()
			this.checkedArr[id] = checkArr
			this.checkedArrHalf[id] = halfArr
		},
		divClick (data, index) {
			for (var i = 0; i < this.divList.length; i++) {
				if (index === i) {
					this.divList[i].class = true
				} else {
					this.divList[i].class = false
				}
			}
			this.id = data.code
		}
	}
}
</script>
<style lang="stylus" scoped>
    .container{
		display:flex;
		flex-direction:row;
		margin-left:100px;
		margin-top:20px
		.tab-box{
			display :flex;
			flex-direction :column;
			overflow-y: auto;
			height:600px;
			width:200px;
			.check{
				cursor:pointer;
				margin: 0px 10px;
				width :145px;
				height :45px;
				line-height :45px;
				border:1px solid var(--fx-primary-color);
				border-bottom :1px solid var(--fx-primary-color)
				font-size :14px;
				color :var(--fx-primary-color);
				background-color :#E4F3FA
			}
			.check:nth-child(1){
				cursor:pointer;
				border-radius:9px 9px 0px 0px;
				margin: 0px 10px;
				width :145px;
				height :45px;
				line-height :45px;
				border:1px solid var(--fx-primary-color);
				border-bottom :1px solid var(--fx-primary-color)
				font-size :14px;
				color :var(--fx-primary-color);
				background-color :#E4F3FA
			}
			.check:last-child{
				cursor:pointer;
				border-radius:0px 0px 9px 9px;
				margin: 0px 10px;
				width :145px;
				height :45px;
				line-height :45px;
				border:1px solid var(--fx-primary-color);
				font-size :14px;
				color :var(--fx-primary-color);
				background-color :#E4F3FA
			}
			.no-check{
				cursor:pointer;
				margin:0px 10px;
				width :145px;
				height :45px;
				line-height :45px;
				font-size :14px;
				border:1px solid #EBEEF5;
				border-bottom :0px
				color :#ADADAD
			}
			.no-check:nth-child(1){
				cursor:pointer;
				border-radius:9px 9px 0px 0px;
				margin:0px 10px;
				width :145px;
				height :45px;
				line-height :45px;
				font-size :14px;
				border:1px solid #EBEEF5;
				border-bottom :0px
				color :#ADADAD
			}
			.no-check:last-child{
				cursor:pointer;
				border-radius:0px 0px 9px 9px;
				margin:0px 10px;
				width :145px;
				height :45px;
				line-height :45px;
				font-size :14px;
				border:1px solid #EBEEF5;
				color :#ADADAD
			}
		}
		.tab-box::-webkit-scrollbar {
			width: 4px;
		}
		.tab-box::-webkit-scrollbar-thumb {
			background-color:#d9d9d9;
		}
		.tree-box{
			.btn-box{
				width:120px;
				margin-bottom:20px
				.btn{
					font-size :15px
					width :80px
				}
			}
			width:250px;
		}
	}

</style>
<style lang="stylus">
.permissions {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
